export default __webpack_public_path__ + "static/media/orange-star.cf178677.svg";